import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/th.js' // นำเข้าภาษาไทย

Vue.use(Element, { locale }) // กำหนดให้ใช้ภาษาไทย
